import { useState, useEffect } from 'react';
import { publicAssetUrl } from '@/services/gameApi';

interface AvatarSprites {
  [playerNumber: number]: HTMLImageElement[];
}

function loadImage(fileName: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error(`Failed to load ${fileName}`));
    img.src = publicAssetUrl(fileName);
  });
}

export function useAvatarSprites() {
  const [avatarSprites, setAvatarSprites] = useState<AvatarSprites>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const sprites: AvatarSprites = {};
        for (let playerNum = 1; playerNum <= 6; playerNum++) {
          sprites[playerNum] = await Promise.all(
            [1, 2, 3, 4].map((frame) => loadImage(`player${playerNum}-front-frame${frame}.png`)),
          );
        }
        if (!cancelled) setAvatarSprites(sprites);
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load avatar sprites');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { avatarSprites, loading, error };
}
